// Helpers for rendering CMS values.

// Inline editing attribute for one database value: "<table>:<row id>:<column>".
// Returns undefined when the row has no id (fallback content), so nothing untraceable is tagged.
export const cms = (table: string, id: string | null | undefined, column: string): string | undefined =>
    id ? `${table}:${id}:${column}` : undefined

// Content the owner still has to supply is written in square brackets, e.g. "[Bitte ergänzen: ...]".
export const isPlaceholder = (value: string | null | undefined): boolean =>
    Boolean(value && value.trim().startsWith('['))

export const hasValue = (value: string | null | undefined): value is string =>
    Boolean(value && value.trim() !== '')

const UMLAUTS: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' }

export const slugify = (value: string): string =>
    value
        .toLowerCase()
        .replace(/[äöüß]/g, letter => UMLAUTS[letter] ?? letter)
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')

export const toTelHref = (phone: string): string => `tel:${phone.replace(/[^\d+]/g, '')}`

export const toWhatsAppHref = (phone: string): string => `https://wa.me/${phone.replace(/\D/g, '').replace(/^00/, '')}`

export const toExternalHref = (value: string, platform?: 'instagram' | 'tiktok' | 'youtube'): string => {
    const trimmed = value.trim()

    if (/^https?:\/\//i.test(trimmed)) return trimmed

    if (trimmed.startsWith('@') && platform) {
        const handle = trimmed.slice(1)

        if (platform === 'instagram') return `https://www.instagram.com/${handle}`
        if (platform === 'tiktok') return `https://www.tiktok.com/@${handle}`

        return `https://www.youtube.com/@${handle}`
    }

    return `https://${trimmed.replace(/^\/+/, '')}`
}

// Two-digit step numbers: 01, 02, ...
export const padNumber = (index: number): string => String(index + 1).padStart(2, '0')
